export { PrizmToTypeModule } from './to-type.module';
export { PrizmToTypePipe } from './to-type.pipe';
